import { TEmailAPIMetrics } from "./types"
import "./styles.scss"
import { KeyEngagementMetrics } from "../components/analytics/keyEngagementMetrics"
import { useContext, useEffect, useState } from "react"
import { EmailAPIContext } from "../context"
import { EngagementTrends } from "../components/analytics/engagementTrends"
import { useTranslation } from "react-i18next"
import { EmailAPIFactory, TEmailReport } from "@cakemail-org/ui-components-v2"
import { getAPIDateRange, getIntervalBasedOnTimeRange } from "../../../utils/date"
import { fillMissingReportIntervals, returnEmailTagsQuery, returnProviderQuery } from "../../../utils/data"
import { emptyReportLog } from "../../../data/emailAPI"
import { Stack } from "@mui/material"

export function EmailAPIMetrics({ }: TEmailAPIMetrics) {
    const { t } = useTranslation()
    const { timeRange, trendRange, tagsFilter, providerFilter, filterOperator, refreshKey } = useContext(EmailAPIContext)

    const [loading, setLoading] = useState<boolean>(true)
    const [metrics, setMetrics] = useState<TEmailReport[]>()
    const [error, setError] = useState<boolean>(false)

    useEffect(fetchLogs, [timeRange, trendRange, tagsFilter, refreshKey])
    function fetchLogs() {
        setLoading(true)
        const interval = getIntervalBasedOnTimeRange(timeRange)
        const apiTimeRange = getAPIDateRange({ range: timeRange })

        EmailAPIFactory.getReport({
            interval: interval,
            tags: returnEmailTagsQuery(tagsFilter, { operator: filterOperator }),
            providers: returnProviderQuery({ providers: providerFilter, operator: filterOperator }),
            startTime: apiTimeRange.start,
            endTime: apiTimeRange.end,
        }).then((data) => {
            try {
                fillMissingReportIntervals(data, apiTimeRange.start, apiTimeRange.end, interval, emptyReportLog)
            } catch (e) {
                setError(true)
                return
            }

            setMetrics(data)
            setLoading(false)
            setError(false)
        }).catch(() => {
            setError(true)
        })
    }

    const engagementTrendsProps = {
        metrics: metrics ?? undefined,
        trendMetrics: metrics ?? undefined,
        //todo re add when trend dorpdown is back and working with graph
        //trendMetrics: splitMetricsForTrends?.firstArray,
        error,
        loading
    }

    return <Stack className="emailAPIMetrics" gap={8}>
        <KeyEngagementMetrics
            refreshKey={refreshKey}
            timeRange={timeRange}
            tagsFilter={tagsFilter}
            providerFilter={providerFilter}
            filterOperator={filterOperator}
        />

        <EngagementTrends
            controlled
            controlledProps={engagementTrendsProps}
            headingTxt={t("header-positive-trends-heading")}
            headingTooltipTxt={t("header-positive-trends-heading-tooltip")}
            availableNavItem={["unique_click_rate", "click_rate", "clickthru_rate", "open_rate", "unique_open_rate"]}
            timeRange={timeRange}
            tagsFilter={tagsFilter}
            providerFilter={providerFilter}
            trendRange={trendRange}
            filterOperator={filterOperator}
        />

        <EngagementTrends
            controlled
            controlledProps={engagementTrendsProps}
            headingTxt={t("header-negative-trends-heading")}
            headingTooltipTxt={t("header-negative-trends-heading-tooltip")}
            availableNavItem={["unsubscribe_rate", "bounce_rate", "spam_rate", "reject_rate"]}
            timeRange={timeRange}
            tagsFilter={tagsFilter}
            providerFilter={providerFilter}
            trendRange={trendRange}
            filterOperator={filterOperator}
        />
    </Stack>
}